export interface ContactItem {
  name: string;
  email: string;
  source: string;
  title?: string;
  company?: string;
}

export interface ContactsPayload {
  type: "contacts";
  query: string;
  totalResults: number;
  contacts: ContactItem[];
}

const isString = (v: unknown): v is string => typeof v === "string";
const isNumber = (v: unknown): v is number => typeof v === "number" && Number.isFinite(v);

const isContactItem = (v: unknown): v is ContactItem => {
  if (!v || typeof v !== "object") return false;
  const r = v as Record<string, unknown>;
  return (
    isString(r.name) &&
    isString(r.email) &&
    isString(r.source) &&
    (r.title === undefined || isString(r.title)) &&
    (r.company === undefined || isString(r.company))
  );
};

export const parseContactsPayload = (v: unknown): ContactsPayload | null => {
  if (!v || typeof v !== "object") return null;
  const r = v as Record<string, unknown>;
  if (r.type !== "contacts") return null;
  if (!isString(r.query)) return null;
  if (!isNumber(r.totalResults)) return null;
  if (!Array.isArray(r.contacts) || !r.contacts.every(isContactItem)) return null;
  return {
    type: "contacts",
    query: r.query,
    totalResults: r.totalResults,
    contacts: r.contacts,
  };
};
